export const ITEM_TTL_ES = 'Artículos';
export interface IItemBase {
  code: string;
  name: string;
  activesIngredientsIds: number[];
  therapistGroupsIds: number[];
  activesIngredients: string;
  therapistGroups: string;
}
export interface IItem extends IItemBase {
  id: number;
}
export type IItemUpdate = Partial<IItemBase>;
